/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Container } from '@nfs-react/components';

import { useText, useImg } from 'hooks';
import { DESKTOP, MOBILE, TABLET } from 'helpers/styles/media';
import { ChangeableBackgroundSection, ChangeableButtonBg, Button } from 'helpers/components';

import { ButtonStyles } from '../UI/UI';

const Features = ({ handleScroll }) => {
  return (
    <ChangeableBackgroundSection
      id="features-wrapper-bg"
      defaultStyle={{ backgroundColor: 'transparent' }}
    >
      <Wrapper>
        <FeaturesContainer isSticky>
          <Title>{useText('features__title', true)}</Title>
          <List>
            {[...Array(3)].map((i, idx) => {
              const index = idx + 1;
              return (
                <Item key={index}>
                  <ItemIcon>
                    {useImg(
                      `features-icon-${index}.svg`,
                      `features__icon_${index}`,
                    )}
                  </ItemIcon>
                  <ItemText>
                    {useText(`features_item__text_${index}`, true)}
                  </ItemText>
                </Item>
              );
            })}
          </List>
          <ChangeableButtonBg
            id="features-button-background"
            defaultColor="#1d9752"
            buttonContainerCss={buttonContainerCss}
          >
            <Button
              buttonCss={buttonStyles}
              clickHandler={handleScroll}
            >
              {useText('features__btn', true)}
            </Button>
          </ChangeableButtonBg>
        </FeaturesContainer>
      </Wrapper>
    </ChangeableBackgroundSection>
  );
};

const buttonContainerCss = css`
  width: 100%;
`;

const Wrapper = styled.section`
  padding: 15px 0;

  @media ${MOBILE} {
    padding: 21px 0;
  }
`;

const FeaturesContainer = styled(Container)`
  @media ${DESKTOP} {
    padding-inline-end: 415px;
  }
`;

const Title = styled.div`
  text-align: center;
  margin-bottom: 48px;
  font-weight: 700;
  font-size: 36px;
  line-height: 48px;
  color: #000000;

  @media ${TABLET} {
    margin-bottom: 23px;
    font-size: 34px;
    line-height: 43px;
  }

  @media ${MOBILE} {
    font-size: 22px;
    line-height: 32px;
    margin-bottom: 55px;
  }
`;

const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 38px;

  @media ${MOBILE} {
    margin-bottom: 37px;
    justify-content: center;
    flex-direction: column-reverse;
    align-items: center;
  }
`;

const Item = styled.div`
  text-align: center;
  width: 255px;

  @media ${TABLET} {
    width: 234px;
  }

  @media ${MOBILE} {
    &:not(:first-child) {
      margin-bottom: 12px;
    }
  }
`;

const ItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  margin-bottom: 40px;

  @media ${TABLET} {
    margin-bottom: 34px;
  }

  @media ${MOBILE} {
    margin-bottom: 38px;
  }
`;

const ItemText = styled.div`
  font-weight: 400;
  font-size: 17px;
  line-height: 28px;
  color: #000000;
`;

const buttonStyles = css`
  ${ButtonStyles}

  width: 100%;
  margin: 0 auto;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  padding: 20px;
  max-width: 400px;

  @media ${TABLET} {
    max-width: 385px;
  }

  @media ${MOBILE} {
    max-width: 300px;
    padding: 20px;
  }
`;

Features.propTypes = {
  handleScroll: PropTypes.func.isRequired,
};

export default Features;
